import * as React from 'react';
import { connect } from 'react-redux';

import BaseReportingPage from '../base/BaseReportingPage';
import InstagramPostsReporting from '../../components/instagram-posts-reporting/InstagramPostsReporting';

import {
  fetchAudienceImpressionsData,
  fetchIgPostReport,
  resetIgPostReport } from '../../reducers/instagram-posts-reporting';

import { mapInstagramInfluencersById } from 'selectors/reporting';

import { __t, applyTranslations } from 'utils/language';

import type { Campaign, Params } from 'types';
import type {
  InstagramPostsReporting as InstagramPostsReportingAlias,
  InstagramPostsReportingAudienceComponentData,
  ReportingSummaryInfluencersMap
} from 'modules/reporting/types';

applyTranslations(require('./ig-post-page.i18n.json'));

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign,
  instagramPostsReporting: InstagramPostsReportingAlias,
  isLoading: boolean,
  audienceData: InstagramPostsReportingAudienceComponentData,
  hasDefinedAttribution: boolean,
  influencersMapById: ReportingSummaryInfluencersMap
};

type DispatchProps = {
  dispatchFetchIgPostReport: (campaignId: number) => void,
  dispatchResetIgPostReport: () => void,
  dispatchFetchAudienceImpressionsData: (campaignId: number) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const IgPostPage = (
  {
    params,
    campaign,
    instagramPostsReporting,
    isLoading,
    audienceData,
    influencersMapById,
    hasDefinedAttribution,
    dispatchFetchAudienceImpressionsData,
    dispatchFetchIgPostReport,
    dispatchResetIgPostReport
  }: Props
): JSX.Element => {
  const campaignId = Number(params.id);

  React.useEffect(() => {
    if (campaignId) {
      dispatchFetchIgPostReport(campaignId);
      dispatchFetchAudienceImpressionsData(campaignId);
    }

    return dispatchResetIgPostReport;
  }, [campaignId]);

  return (
    <BaseReportingPage
      headline={__t('ig_post_report_page.title')}
      params={params}
    >
      <InstagramPostsReporting
        campaign={campaign}
        instagramPostsReporting={instagramPostsReporting}
        isLoading={isLoading}
        audienceData={audienceData}
        hasDefinedAttribution={hasDefinedAttribution}
        influencersMapById={influencersMapById}
      />
    </BaseReportingPage>
  );
};

const mapStateToProps = (
  { campaignBrief,
    instagramPostsReporting: { instagramPostsReporting, isLoading, audienceData },
    reportingMetaInfo }
): StateProps => ({
  campaign: campaignBrief.brief,
  instagramPostsReporting,
  isLoading,
  audienceData,
  hasDefinedAttribution: reportingMetaInfo.metaInfo.hasDefinedAttribution,
  influencersMapById: mapInstagramInfluencersById(instagramPostsReporting)
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchIgPostReport: (campaignId: number) => (
    dispatch(fetchIgPostReport(campaignId))
  ),
  dispatchResetIgPostReport: () => (
    dispatch(resetIgPostReport())
  ),
  dispatchFetchAudienceImpressionsData: (campaignId: number) => (
    dispatch(fetchAudienceImpressionsData(campaignId))
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(IgPostPage);
